import { render, staticRenderFns } from "./bar.vue?vue&type=template&id=125a61f8&scoped=true"
import script from "./bar.vue?vue&type=script&lang=js"
export * from "./bar.vue?vue&type=script&lang=js"
import style0 from "./bar.vue?vue&type=style&index=0&id=125a61f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125a61f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('125a61f8')) {
      api.createRecord('125a61f8', component.options)
    } else {
      api.reload('125a61f8', component.options)
    }
    module.hot.accept("./bar.vue?vue&type=template&id=125a61f8&scoped=true", function () {
      api.rerender('125a61f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home-page/compontents-cool/bar.vue"
export default component.exports